module.exports = __webpack_public_path__ + "img/10979913_L.8bf29603.png";